<template lang="pug">
b-modal#editAds(
  ref="editAds"
  :title="$t('ui.combine.edit_ads')"
  centered
  no-fade
  no-close-on-backdrop
  size="lg"
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .row(v-if="item")
      .col-6
        b-form-group(:label="$t('ui.ads_id')" disabled).mb-0
          DebounceInput(
            size="sm"
            ref="ads_id"
            type="text"
            v-model.trim.lazy="item.ads_id"
            :disabled="loading"
            name="editads1"
          )
      .col-6
        b-form-group(:label="$t('ui.provider_code')" disabled).mb-0
          DebounceInput(
            size="sm"
            ref="provider_code"
            type="text"
            v-model.trim.lazy="item.provider_code"
            :disabled="loading"
            name="editads2"
          )
      .col-6
        b-form-group(:label="$t('ui.domain')" disabled).mb-0
          DebounceInput(
            size="sm"
            ref="domain"
            type="text"
            v-model.trim.lazy="item.domain_name"
            :disabled="loading"
            name="editads15"
          )
      template(v-if="item.provider_code.toLowerCase() == 'pixel'")
        .col-6
          b-form-group(:label="$t('ui.px_token')").mb-0
            DebounceInput(
              size="sm"
              ref="px_token"
              type="text"
              :dirty="$v.px_token.$dirty"
              :error="$v.px_token.$error"
              v-model.trim.lazy="$v.px_token.$model"
              :disabled="loading"
              name="editads3"
            )
            ValidateResult(:value="$v.px_token" :name="$t('ui.px_token')")
        .col-6
          b-form-group(:label="$t('ui.px_pixel_id')").mb-0
            DebounceInput(
              size="sm"
              ref="px_pixel_id"
              type="text"
              :dirty="$v.px_pixel_id.$dirty"
              :error="$v.px_pixel_id.$error"
              v-model.trim.lazy="$v.px_pixel_id.$model"
              :disabled="loading"
              name="editads4"
            )
            ValidateResult(:value="$v.px_pixel_id" :name="$t('ui.px_pixel_id')")
      template(v-else-if="item.provider_code.toLowerCase() == 'appsflyer'")
        .col-6
          b-form-group(:label="$t('ui.af_apps_id')").mb-0
            DebounceInput(
              size="sm"
              ref="af_apps_id"
              type="text"
              :dirty="$v.af_apps_id.$dirty"
              :error="$v.af_apps_id.$error"
              v-model.trim.lazy="$v.af_apps_id.$model"
              :disabled="loading"
              name="editads5"
            )
            ValidateResult(:value="$v.af_apps_id" :name="$t('ui.af_apps_id')")
        .col-6
          b-form-group(:label="$t('ui.af_dev_key')").mb-0
            DebounceInput(
              size="sm"
              ref="af_dev_key"
              type="text"
              :dirty="$v.af_dev_key.$dirty"
              :error="$v.af_dev_key.$error"
              v-model.trim.lazy="$v.af_dev_key.$model"
              :disabled="loading"
              name="editads6"
            )
            ValidateResult(:value="$v.af_dev_key" :name="$t('ui.af_dev_key')")
      template(v-else-if="item.provider_code.toLowerCase() == 'propeller'")
        .col-6
          b-form-group(:label="$t('ui.pp_aid')").mb-0
            DebounceInput(
              size="sm"
              ref="pp_aid"
              type="text"
              :dirty="$v.pp_aid.$dirty"
              :error="$v.pp_aid.$error"
              v-model.trim.lazy="$v.pp_aid.$model"
              :disabled="loading"
              name="editads7"
            )
            ValidateResult(:value="$v.pp_aid" :name="$t('ui.pp_aid')")
        .col-6
          b-form-group(:label="$t('ui.pp_pid')").mb-0
            DebounceInput(
              size="sm"
              ref="pp_pid"
              type="text"
              v-model.trim.lazy="pp_pid"
              :disabled="loading"
              name="editads8"
            )
        .col-6
          b-form-group(:label="$t('ui.pp_tid')").mb-0
            DebounceInput(
              size="sm"
              ref="pp_tid"
              type="text"
              :dirty="$v.pp_tid.$dirty"
              :error="$v.pp_tid.$error"
              v-model.trim.lazy="$v.pp_tid.$model"
              :disabled="loading"
              name="editads9"
            )
            ValidateResult(:value="$v.pp_tid" :name="$t('ui.pp_tid')")
      template(v-else-if="item.provider_code.toLowerCase() == 'gtm'")
        .col-6
          b-form-group(:label="$t('ui.gtm_id')").mb-0
            DebounceInput(
              size="sm"
              ref="gtm_id"
              type="text"
              :dirty="$v.gtm_id.$dirty"
              :error="$v.gtm_id.$error"
              v-model.trim.lazy="$v.gtm_id.$model"
              :disabled="loading"
              name="editads10"
            )
            ValidateResult(:value="$v.gtm_id" :name="$t('ui.pp_tid')")
      template(v-if="item.provider_code.toLowerCase() == 'tiktok'")
        .col-6
          b-form-group(:label="$t('ui.tt_token')").mb-0
            DebounceInput(
              size="sm"
              ref="tt_token"
              type="text"
              :dirty="$v.tt_token.$dirty"
              :error="$v.tt_token.$error"
              v-model.trim.lazy="$v.tt_token.$model"
              :disabled="loading"
              name="editads3"
            )
            ValidateResult(:value="$v.tt_token" :name="$t('ui.tt_token')")
        .col-6
          b-form-group(:label="$t('ui.tt_pixel_id')").mb-0
            DebounceInput(
              size="sm"
              ref="tt_pixel_id"
              type="text"
              :dirty="$v.tt_pixel_id.$dirty"
              :error="$v.tt_pixel_id.$error"
              v-model.trim.lazy="$v.tt_pixel_id.$model"
              :disabled="loading"
              name="editads4"
            )
            ValidateResult(:value="$v.tt_pixel_id" :name="$t('ui.tt_pixel_id')")
      template(v-if="item.provider_code.toLowerCase() != 'pixel' && item.provider_code.toLowerCase() != 'tiktok'")
        template(v-if="item.provider_code.toLowerCase() != 'gtm' && item.provider_code != ''")
          .col-12
            b-form-group(:label="$t('ui.service_provider_url')").mb-0
              b-form-textarea(
                ref="service_provider_url"
                :dirty="$v.service_provider_url.$dirty"
                :error="$v.service_provider_url.$error"
                v-model.trim.lazy="$v.service_provider_url.$model"
                style="height:70px;"
                name="editads11"
              )
              ValidateResult(:value="$v.service_provider_url" :name="$t('ui.service_provider_url')")
        .col-12
          b-form-group(:label="$t('ui.script_inject')").mb-2
            div.d-flex
              label.custom-switch
                input.custom-switch-input(
                  type="checkbox"
                  required
                  :dirty="$v.script_inject.$dirty"
                  :error="$v.script_inject.$error"
                  v-model.trim.lazy="$v.script_inject.$model"
                  :disabled="loading"
                  name="editads12"
                )
                span.custom-switch-indicator
            ValidateResult(:value="$v.script_inject" :name="$t('ui.script_inject')")

        template(v-if="script_inject")
          .col-12
            b-form-group(:label="$t('ui.head_script')")
              b-form-textarea(
                ref="head_script"
                :dirty="$v.head_script.$dirty"
                :error="$v.head_script.$error"
                v-model.trim.lazy="$v.head_script.$model"
                style="height:97px;"
                name="editads13"
              )
              ValidateResult(:value="$v.head_script" :name="$t('ui.head_script')")
          .col-12
            b-form-group(:label="$t('ui.body_script')")
              b-form-textarea(
                ref="body_script"
                :dirty="$v.body_script.$dirty"
                :error="$v.body_script.$error"
                v-model.trim.lazy="$v.body_script.$model"
                style="height:97px;"
                name="editads14"
              )
              ValidateResult(:value="$v.body_script" :name="$t('ui.body_script')")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import AdsProviderLookup from "@/library/AdsProviderLookup.vue";
import AdsDomainOperatorLookup from "@/library/AdsDomainOperatorLookup.vue";


export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    AdsProviderLookup,
    AdsDomainOperatorLookup
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      ads_id: "",
      provider_code: "",
      domain_name: "",
      px_token: "",
      px_pixel_id: "",
      af_apps_id: "",
      af_dev_key: "",
      pp_aid: "",
      pp_pid: "",
      pp_tid: "",
      gtm_id: "",
      tt_token: "",
      tt_pixel_id: "",
      service_provider_url: "",
      head_script: "",
      body_script: "",
      script_inject: false
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    pixelProviderStart() {
      return config.pixelProviderStart;
    },
    pixelProviderEnd() {
      return config.pixelProviderEnd;
    },
    pixelHeaderStart() {
      return config.pixelHeaderStart;
    },
    pixelHeaderEnd() {
      return config.pixelHeaderEnd;
    },
    pixelBodyStart() {
      return config.pixelBodyStart;
    },
    pixelBodyEnd() {
      return config.pixelBodyEnd;
    },
    tiktokProvider() {
      return config.tiktokProvider;
    },
    tiktokHeaderStart() {
      return config.tiktokHeaderStart;
    },
    tiktokHeaderEnd() {
      return config.tiktokHeaderEnd;
    },
  },
  validations: {
    px_token: {
      required
    },
    px_pixel_id: {
      required
    },
    af_apps_id: {
      required
    },
    af_dev_key: {
      required
    },
    pp_aid: {
      required
    },
    pp_tid: {
      required
    },
    gtm_id: {
      required
    },
    tt_token: {
      required
    },
    tt_pixel_id: {
      required
    },
    service_provider_url: {
      required: requiredIf(function () {
        return !['pixel','tiktok'].includes(this.provider_code.toLowerCase());
      })
    },
    script_inject: {
      required
    },
    head_script: {
      headBodyScriptEitherOne: function(value) {
        if (this.provider_code === 'pixel') {
          return true;
        }

        if (this.provider_code === 'tiktok') {
          return true;
        }

        const isValueEmpty = value === '' || value === null;
        const isBodyScriptEmpty = this.body_script === '' || this.body_script === null;

        if (isValueEmpty && isBodyScriptEmpty) {
          return false;
        }

        return true;
      }
    },
    body_script: {
      headBodyScriptEitherOne: function(value) {
        if (this.provider_code === 'pixel') {
          return true;
        }

        if (this.provider_code === 'tiktok') {
          return true;
        }

        const isValueEmpty = value === '' || value === null;
        const isHeadScriptEmpty = this.head_script === '' || this.head_script === null;

        if (isValueEmpty && isHeadScriptEmpty) {
          return false;
        }

        return true;
      }
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      // this.$v.$touch();
      this.$v.$reset();
      var isInvalid = this.validateInfo();
      // this.$v.head_script.$touch();
      if (!isInvalid) {
        this.proceed();
      }
    },
    proceed() {
      let url = config.adsProviderEditUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        ads_id: this.ads_id,
        px_token: this.provider_code.toLowerCase() == 'pixel' ? this.px_token : null,
        px_pixel_id: this.provider_code.toLowerCase() == 'pixel' ? this.px_pixel_id : null,
        af_apps_id: this.provider_code.toLowerCase() == 'appsflyer' ? this.af_apps_id : null,
        af_dev_key: this.provider_code.toLowerCase() == 'appsflyer' ? this.af_dev_key : null,
        pp_aid: this.provider_code.toLowerCase() == 'propeller' ? this.pp_aid : null,
        pp_pid: this.provider_code.toLowerCase() == 'propeller' ? this.pp_pid : null,
        pp_tid: this.provider_code.toLowerCase() == 'propeller' ? this.pp_tid : null,
        gtm_id: this.provider_code.toLowerCase() == 'gtm' ? this.gtm_id : null,
        tt_token: this.provider_code == 'tiktok' ? this.tt_token : null,
        tt_pixel_id: this.provider_code == 'tiktok' ? this.tt_pixel_id : null,
        // service_provider_url: this.provider_code.toLowerCase()!= 'gtm' ? this.service_provider_url : null,
        // head_script: this.script_inject == true ? this.head_script : null,
        // body_script: this.script_inject == true ? this.body_script : null,
        // script_inject: this.script_inject
      };

      if(this.provider_code.toLowerCase() == 'pixel') {
        json.service_provider_url = this.pixelProviderStart + this.px_pixel_id + this.pixelProviderEnd + this.px_token
        json.head_script = this.pixelHeaderStart + this.px_pixel_id + this.pixelHeaderEnd
        json.body_script = this.pixelBodyStart + this.px_pixel_id + this.pixelBodyEnd
        json.script_inject = true
      }
      else if(this.provider_code == 'tiktok') {
        json.service_provider_url = this.tiktokProvider
        json.head_script = this.tiktokHeaderStart + this.tt_pixel_id + this.tiktokHeaderEnd
        json.body_script = null
        json.script_inject = true
      }
      else {
        json.service_provider_url = this.provider_code.toLowerCase()!= 'gtm' ? this.service_provider_url : null,
        json.head_script = this.script_inject == true ? this.head_script : null,
        json.body_script = this.script_inject == true ? this.body_script : null,
        json.script_inject = this.script_inject
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.editAds.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "edit_ads", this.feedback.status);
                this.$refs.editAds.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    confirmSubmit() {
      var isValid = validateInfo();
      this.proceed();
    },
    validateInfo() {
      var isInvalid = false;

      if(this.script_inject) {
        this.$v.head_script.$touch();
        this.$v.body_script.$touch();
        if(this.$v.head_script.$invalid) isInvalid = true
        if(this.$v.body_script.$invalid) isInvalid = true
      }

      // if(this.provider_code == '') return;

      if(this.provider_code.toLowerCase() != 'gtm') {
        this.$v.service_provider_url.$touch();
        if(this.$v.service_provider_url.$invalid) isInvalid = true

        if(this.provider_code.toLowerCase() == 'pixel') {
          this.$v.px_token.$touch();
          if(this.$v.px_token.$invalid) isInvalid = true

          this.$v.px_pixel_id.$touch();
          if(this.$v.px_pixel_id.$invalid) isInvalid = true

        } else if(this.provider_code.toLowerCase() == 'appsflyer') {
          this.$v.af_apps_id.$touch();
          if(this.$v.af_apps_id.$invalid) isInvalid = true

          this.$v.af_dev_key.$touch();
          if(this.$v.af_dev_key.$invalid) isInvalid = true
        } else if(this.provider_code.toLowerCase() == 'propeller') {
          this.$v.pp_aid.$touch();
          if(this.$v.pp_aid.$invalid) isInvalid = true

          this.$v.pp_tid.$touch();
          if(this.$v.pp_tid.$invalid) isInvalid = true
        } else if(this.provider_code == 'tiktok') {
          this.$v.tt_token.$touch();
          if(this.$v.tt_token.$invalid) isInvalid = true

          this.$v.tt_pixel_id.$touch();
          if(this.$v.tt_pixel_id.$invalid) isInvalid = true
        }
      } else {
        this.$v.gtm_id.$touch();
        if(this.$v.gtm_id.$invalid) isInvalid = true
      }

      return isInvalid
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    getAdsDetail: function() {
      let url = config.adsProviderDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        ads_id: this.ads_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                var ads = response.data.ds.ads
                var script = response.data.ds.script;

                if(ads.length > 0) {
                  var adsInfo = ads[0];
                  this.px_token = adsInfo.px_token
                  this.px_pixel_id = adsInfo.px_pixel_id
                  this.af_apps_id = adsInfo.af_apps_id
                  this.af_dev_key = adsInfo.af_dev_key
                  this.pp_aid = adsInfo.pp_aid
                  this.pp_pid = adsInfo.pp_pid
                  this.pp_tid = adsInfo.pp_tid
                  this.gtm_id = adsInfo.gtm_id
                  this.tt_token = adsInfo.tt_token
                  this.tt_pixel_id = adsInfo.tt_pixel_id
                  this.service_provider_url = adsInfo.service_provider_url
                  this.script_inject = adsInfo.script_inject
                }

                if(script.length > 0) {
                  for(var i = 0; i < script.length; i++) {
                    var scriptInfo = script[i];

                    if(scriptInfo.section == 'HEAD')
                      this.head_script = scriptInfo.script
                    if(scriptInfo.section == 'BODY')
                      this.body_script = scriptInfo.script
                  }
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    shown: function() {
      this.$v.$reset();
      this.ads_id = this.item.ads_id;
      this.loading = false
      this.provider_code = this.item.provider_code
      this.px_token = ""
      this.px_pixel_id = ""
      this.af_apps_id = ""
      this.af_dev_key = ""
      this.pp_aid = ""
      this.pp_pid = ""
      this.pp_tid = ""
      this.gtm_id = ""
      this.tt_token = ""
      this.tt_pixel_id = ""
      this.service_provider_url = ""
      this.head_script = ""
      this.body_script = ""
      this.script_inject = false
      this.getAdsDetail();
    }
  }
};
</script>
